import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  styled,
} from "@mui/material";

export const StyledPopup = styled(Dialog)`
  .MuiDialog-paper {
    padding: ${(props) =>
      `${props.theme.wsc.spacing[3]} ${props.theme.wsc.spacing[3]} ${props.theme.wsc.spacing[2]} ${props.theme.wsc.spacing[3]}`};
    background-color: ${(props) => props.theme.wsc.palette.neutral[800]};
    border: 0.071rem solid ${(props) => props.theme.wsc.palette.neutral[500]};
    border-radius: ${(props) => props.theme.wsc.radius.m};
  }
`;

export const StyledPopupTitle = styled(DialogTitle)`
  font-size: ${(props) => props.theme.wsc.typography.header5.fontSize};
  font-weight: ${(props) => props.theme.wsc.typography.header5.fontWeight};
  line-height: ${(props) => props.theme.wsc.typography.header5.lineHeight};
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  margin-bottom: ${(props) => props.theme.wsc.spacing[2]};
  padding: 0;
`;

export const StyledPopupContent = styled(DialogContent)`
  font-size: ${(props) => props.theme.wsc.typography.body1.fontSize};
  font-weight: ${(props) => props.theme.wsc.typography.body1.fontWeight};
  line-height: ${(props) => props.theme.wsc.typography.body1.lineHeight};
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  padding: 0 0 ${(props) => props.theme.wsc.spacing[2]};
  margin-bottom: ${(props) => props.theme.wsc.spacing[2]};
  border-bottom-color: ${(props) => props.theme.wsc.palette.neutral[500]};
  border-top: 0;
`;

export const StyledPopupActions = styled(DialogActions)`
  padding: 0;
`;

export const FooterLeftSideContentContainer = styled("div")`
  display: flex;
  flex: 1;
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  gap: ${(props) => props.theme.wsc.spacing[1]};
`;

export const StyledHeader = styled("div")`
  display: flex;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
  > span {
    line-height: ${({ theme }) => theme.wsc.typography.header5.lineHeight};
  }
`;

export const StyledCloseButton = styled("div")`
  margin-left: auto;
`;
